import React from "react";
import "./header.scss";

const Header = (props: any) => {
    return (
        <header className="header">
            <h1>{props.title}</h1>
        </header>
    )
}

export default Header;